import { Component, Input, OnInit } from '@angular/core'
import { ModalService } from 'src/app/services/modal/modal.service'
import { UserService } from 'src/app/services/user/user.service'

@Component({
  selector: 'app-web-install-choice-modal',
  templateUrl: './web-install-choice-modal.component.html',
  styleUrls: ['./web-install-choice-modal.component.scss'],
})
export class WebInstallChoiceModalComponent implements OnInit {
  constructor(private modalService: ModalService, private userService: UserService) {}
  @Input() title = ''
  @Input() description = ''
  @Input() alertText = ''
  @Input() logOnClickWeb: (() => void) | undefined
  @Input() logOnClickInstall: (() => void) | undefined
  isLoggedIn = this.userService.isLoggedIn

  ngOnInit() {}

  onClickClose(): void {
    this.modalService.dismiss()
  }

  onClickWeb(): void {
    this.modalService.dismiss({ type: 'web' })
  }

  onClickInstall(): void {
    this.logOnClickInstall?.()
    this.modalService.dismiss({ type: 'app' })
  }
}
